import { Box } from 'gls';
import React, { ReactNode } from 'react';
import { colours } from 'styling/colours';
import { style } from 'typestyle';

export default function FormHeader({ text, bold = false }: { text: string | ReactNode, bold?: boolean }) {
  return (
    <Box className={headerStyle(bold)}>
      {text}
    </Box>
  );
}

const headerStyle = (bold: boolean) => style({
  marginBottom: '10px',
  fontSize: '18px',
  fontWeight: bold ? 'bold' : 'normal',
  color: colours.secondaryText
})